import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ManualLoginGuard implements CanActivate {
  constructor(private msalGuard: MsalGuard) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const manual = localStorage.getItem('manual-logged-in') === 'true';

    if (manual) {
      return true; // ✅ Allow access manually
    } else {
      return this.msalGuard.canActivate(route, state).pipe(
        map(result => {
          if (typeof result === 'boolean') {
            return result;
          } else {
            // 🔄 If result is UrlTree, block access (or optionally redirect)
            return false;
          }
        })
      );
    }
  }
}
